import type React from 'react';

import { CanonicalUrl } from './components/CanonicalUrl';
import { Meta } from './components/Meta';
import { Title } from './components/Title';

export const Head: React.FC = () => {
	return (
		<>
			<Title />
			<CanonicalUrl />
			<Meta />
		</>
	);
};
